export default __webpack_public_path__ + "static/media/PP-logo-blue.fcc3080c.svg";